var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnnxRuntime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.16 62.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Onnx_runtime") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43,47.24l-6.83-9.6L51.54,44l.07.08,0,0,.76.31L63.63,22.42l-27.4,9.22c3.23-3.76,8.37-9.52,10.42-11.82h0l.19-.2.69-.77.12-.14h0l.13-.14h0L48.3,18l0,0L30.79.43V29.26L22.27,14.78v0h0l-.41-.71-22,11.06,26.89,9.05-17,3.34.12.81H9.8l.09.07,3.75,23.78L30.28,39.61,28.59,56.45l.81.15v.13l.15-.11,23,4L43,47.24ZM58,27.3,52,38.86,49.2,30.25ZM49.44,40.05l-7.66-3.16,5-4.92Zm-7.35-7.41-3.15,3.09-2.71-1.12Zm-25.91-5-9-3L19,18.67Zm5.52-8.25,4.18,7.08L19.15,27.6ZM15.37,55.07,13.28,41.8l7.81,5.52Zm6.39-10.73-7-4.94,8-1.57ZM25,42.06l.74-4.8L29,36.61ZM22.77,29.85l4.64-.79L29.13,32Zm14.85-4.17L34.5,19.53h8.6C41.55,21.25,39.54,23.49,37.62,25.68Zm-4-18.44,9.48,9.47H33.61Zm0,16.78,2,3.94-2,2.34Zm-.38,14.34,3.38,4.74L33,41.21Zm-.58,5.87,5.71,3-6.51,5.1ZM46.27,56.68,33.62,54.47l7.12-5.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnnxRuntime);
export default __webpack_public_path__ + "static/media/onnx_runtime.7082594b5871de459b7adf0756355d0e.svg";
export { ForwardRef as ReactComponent };